import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const adminRoleGuard = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (
        authService.userIsAdmin() ||
        authService.userIsFinanceAdmin() ||
        authService.userIsBusinessUnitEditor() ||
        authService.userIsDivisionEditor() ||
        authService.userIsRegionEditor() ||
        authService.userIsNcsEditor()
    ) {
        return true;
    }

    // Redirect to the login page
    return router.parseUrl('');
};
